import { createAsyncThunk, createAction } from '@reduxjs/toolkit';
import {
  disconnectWhatsAppBusinessAccount as disconnectWhatsAppBusinessAccountApi,
  saveWhatsappConnectionResponse as saveWhatsappConnectionResponseApi,
  verifyWhatsAppNumber as verifyWhatsAppNumberApi,
} from 'util/Api/whatsappSelfService';
import { WhatsappParams } from 'interfaces/whatsAppInterfaces';

export const resetShouldOpenOTPForm = createAction('whatsappSelfService/resetShouldOpenOTPForm');
export const resetWhatsAppErrorMessages = createAction(
  'whatsappSelfService/resetWhatsAppErrorMessages',
);
export const disconnectWhatsAppBusinessAccount = createAsyncThunk(
  'whatsappSelfService/disconnect',
  async ({ customerId, phoneNumber }: WhatsappParams, { rejectWithValue }) => {
    try {
      return await disconnectWhatsAppBusinessAccountApi({
        customerId,
        phoneNumber,
      });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const saveWhatsappConnectionResponse = createAsyncThunk(
  'whatsappSelfService/saveResponse',
  async (
    { customerId, wabaId, phoneNumberId, businessProfileName, phoneNumber }: WhatsappParams,
    { rejectWithValue },
  ) => {
    try {
      return await saveWhatsappConnectionResponseApi({
        customerId,
        wabaId,
        phoneNumberId,
        businessProfileName,
        phoneNumber,
      });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const verifyWhatsAppNumber = createAsyncThunk(
  'whatsappSelfService/verifyWhatsAppNumber',
  async ({ customerId, phoneNumber, otp }: WhatsappParams, { rejectWithValue }) => {
    try {
      return await verifyWhatsAppNumberApi({
        customerId,
        phoneNumber,
        otp,
      });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const resetWSSBusinessData = createAsyncThunk(
  'whatsappSelfService/resetWSSBusinessData',
  async ({ customerId, phoneNumber }: WhatsappParams, { rejectWithValue }) => {
    try {
      return await disconnectWhatsAppBusinessAccountApi({
        customerId,
        phoneNumber,
      });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
